<template>
  <div>
    <a-modal
      :centered="true"
      :width="587"
      v-model="showModal"
      :footer="null"
      :height="!closeButton ? '100vh' : null"
      :bodyStyle="{ padding: '24px', height: !closeButton ? '100vh' : null }"
      @cancel="hide"
      :closable="closeButton"
    >
      <div class="heading-container">
        <a-icon
          class="close-icon-size cp mr-3"
          type="close"
          style="font-size: 20px; color:#000000;"
          @click="hide"
        />
        <p class="heading">{{ closeButton ? "Filter Reviews" : "Filter" }}</p>
        <button
          class="apply show"
          :style="{ background: getPrimaryColor() }"
          @click="apply"
        >
          Apply Filters
        </button>
      </div>
      <div
        v-for="(filter_item, index) in reviews_type"
        :key="filter_item"
        class="filter-item"
      >
        <a-radio-group
          v-model:value="filterType"
        >
          <a-radio :value="filterTypeValue[index]"> {{ filter_item }}</a-radio>
        </a-radio-group>
      </div>
      <div class="footer">
        <button class="cancel" @click="hide">Cancel</button>
        <button
          class="apply"
          :style="{ background: getPrimaryColor() }"
          @click="apply"
        >
          Apply Filters
        </button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { faBookOpen } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faBookOpen);

export default {
  name: "ReviewsFilterModal",

  props: {
    handleAnswer: Function,
    type: String,
  },

  data() {
    return {
      showModal: false,
      reviews_type: [
        "In Person Visit",
        "MyCircles Interaction",
        "Online Telemedicine"
      ],
      filterType: "InPerson",
      filterTypeValue: ["InPerson", "MyCircles", "Online"],
      closeButton: true
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth < 700) {
        this.closeButton = false;
      } else {
        this.closeButton = true;
      }
    },
    show() {
      this.showModal = true;
      this.filterType = this.type;
    },
    hide() {
      this.showModal = false;
    },
    apply() {
      this.hide();
      this.handleAnswer(this.filterType);
    }
  }
};
</script>

<style lang="scss" scoped>
.heading-container {
  display: flex;
  align-items: center;
  padding-bottom: 28px;
  .heading {
    font-family: "Lato";
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: #33415f;
    flex: 1;
    margin-bottom: 0px;
    @media screen and (min-width: 701px) {
      font-size: 24px;
      line-height: 32px;
    }
  }
  .close-icon-size {
    @media screen and (min-width: 701px) {
      display: none;
    }
  }
}

.sub-heading {
  font-weight: 700;
  font-size: 16px;
  line-height: 32px;
  color: #647490;
}

.footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}

.cancel {
  padding: 12px 24px;
  background: #e2e8f0;
  border-radius: 6px;
  border: none;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  color: #47556e;
  margin-right: 10px;
}

.apply {
  padding: 12px 24px;
  border-radius: 6px;
  border: none;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
}

.filter-item {
  font-weight: 400;
  font-size: 14px;
  color: #1e2945;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.show {
  @media screen and (min-width: 701px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/ReviewsFilterModal.vue